export const SterilityOptions = [
    {
        description: "Break in Sterile Technique",
        name: "BreakInSterileTechnique",
    },
    {
        description: "Contamination",
        name: "Contamination",
    },   
];